import React from 'react';
import { useNavigate } from 'react-router-dom';
import { HomeIcon, Cog6ToothIcon, InboxArrowDownIcon } from '@heroicons/react/24/solid';
import { useModal } from '../../context/ModalContext';
import Tippy from '@tippyjs/react';
import SessionSettingsModal from '../modals/SessionSettingsModal';
import SessionProgressBar from './SessionProgressBar';
import ThemeToggleButton from '../common/ThemeToggleButton';

// --- CHANGE: Added a 'hoverVariant' prop to allow for different hover colors ---
const IconWithTooltip = ({ content, children, onClick, active = false, hoverVariant = 'primary' }) => {
  const getHoverClasses = () => {
    if (hoverVariant === 'secondary') {
      return 'hover:bg-secondary/10 hover:text-secondary';
    }
    // Default hover variant is primary
    return 'hover:bg-primary/10 hover:text-primary';
  };

  return (
    <Tippy content={content} placement="bottom" arrow={false} delay={[500, 0]}>
      <button
        onClick={onClick}
        // The 'group' class is added to allow child elements to be styled on hover
        className={`group relative p-3 rounded-full transition-all duration-200 ease-in-out hover:-translate-y-0.5 active:scale-95 ${
          active
            ? 'bg-secondary/10 text-secondary' // Active state style
            : `text-content-secondary ${getHoverClasses()}` // Default state + hover style
        }`}
      >
        {children}
      </button>
    </Tippy>
  );
};

const SessionLayout = ({ updateSettings, correctCount, incorrectCount, totalCount, onWrapUp, wrapUpFlag, seenCount }) => {
  const navigate = useNavigate();
  const { showModal, hideModal } = useModal();

  const handleOpenSettings = () => {
    showModal(<SessionSettingsModal onClose={hideModal} updateSettings={updateSettings} />);
  };

  return (
    <header className="w-full bg-background-secondary border-b border-border shadow-sm">
      <div className="flex items-center gap-4 p-2 max-w-6xl mx-auto">
        {/* Left Controls */}
        <div className="flex items-center gap-1">
          <IconWithTooltip content="Back to Dashboard" onClick={() => navigate('/dashboard')}>
            <HomeIcon className="h-6 w-6" />
          </IconWithTooltip>

          {/* --- FIX 3: Added group-hover animation to the Cog icon --- */}
          <div className="session-settings">
            <IconWithTooltip content="Session Settings" onClick={handleOpenSettings}>
              <Cog6ToothIcon className="h-6 w-6 transition-transform duration-300 group-hover:rotate-90" />
            </IconWithTooltip>
          </div>

          {onWrapUp && (
            // --- FIX 1: Set hoverVariant to 'secondary' for this button ---
            <IconWithTooltip content="Wrap Up Session" onClick={onWrapUp} active={wrapUpFlag} hoverVariant="secondary">
              {wrapUpFlag ? (
                // --- FIX 2: Display number next to a pulsing bubble when active ---
                <div className="flex items-center justify-center h-6 w-6 gap-1.5">
                  <span className="font-bold text-base">{seenCount}</span>
                  <div className="h-2 w-2 rounded-full bg-secondary animate-pulse"></div>
                </div>
              ) : (
                <InboxArrowDownIcon className="h-6 w-6" />
              )}
            </IconWithTooltip>
          )}
        </div>

        <div className="flex-grow">
          {/* Desktop version - normal progress bar */}
          <div className="hidden sm:block">
            <SessionProgressBar correct={correctCount} incorrect={incorrectCount} total={totalCount} />
          </div>
          {/* Mobile version - compact progress bar */}
          <div className="block sm:hidden">
            <SessionProgressBar correct={correctCount} incorrect={incorrectCount} total={totalCount} compact />
          </div>
        </div>

        <div>
          <ThemeToggleButton />
        </div>
      </div>
    </header>
  );
};

export default SessionLayout;
